import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useMutation } from '@tanstack/react-query';
import { PsychosocialReportService } from '@/infra/services/psychosocial-report';

interface InitSurveyParams {
	token: string;
	survey_link_id: string;
	employee_id?: string | null;
	employee_code?: string | null;
	participation_id?: string | null;
}

const Service = PsychosocialReportService.getInstance();

export const useInitSurvey = () => {
	return useMutation({
		mutationFn: (params: InitSurveyParams) => Service.initSurvey(params),
		onError: () => {
			message.error(I18n.get('Failed to initialize survey'));
		}
	});
};
